import { describeAge } from '../relativeTime';

const LABELS: Record<string, string> = {
  connected: 'Connected',
  pending: 'Not authorized',
  error: 'Error',
};

/**
 * Connection status, and — when we know it — when that was last true.
 *
 * ⚠ `checkedAt` is not decoration. This badge reports a STORED result, not a
 * live probe, and without the age it will happily say "Connected" about an
 * instance that has been switched off for a week. That happened on September
 * 14, 2026 and is the reason the prop exists.
 *
 * It is not re-probed on render on purpose: contract REST reads are metered
 * against the customer's own API budget, so checking every tenant whenever
 * somebody opens a list would charge them for the privilege of looking.
 */
export function ConnectionBadge({
  status,
  checkedAt,
}: {
  status: string;
  checkedAt?: string | null;
}) {
  const age = describeAge(checkedAt);

  return (
    <>
      <span className={`badge badge-${status}`}>{LABELS[status] ?? status}</span>
      {age && <span className="muted small"> checked {age}</span>}
    </>
  );
}
